import React, { useState, useEffect } from "react";
import { Link, useParams, useNavigate} from "react-router-dom";
import { useFormik } from "formik"; 
import { editProviderSchema } from "../../services/validator";
import { toast } from "react-toastify";
import useToast from "../../helpers/useToast";
import { TextField, Button, Box, Typography, IconButton, InputAdornment, Chip } from "@mui/material";
import Autocomplete from '@mui/material/Autocomplete'; 
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import useEncryption from "../../services/useEncryption";
import { providerDetailsApi } from "../../api/adminApi/adminApi";
import { editProviderApi } from "../../api/adminApi/adminApi";
import useHeaders from "../../helpers/useHeaders";

const EditProvider = () => {

  const toastOptions = useToast();
  const { encryptData, decryptData } = useEncryption();
  const { id } = useParams();
  const navigate = useNavigate();
  const headers = useHeaders();


 useEffect(() => {
    const fetchProvider = async () => {
      try {
        const response = await providerDetailsApi(id); 
        const result = decryptData(response.data.data);
        formik.setValues({
          organizationName: result.organizationName,
          organizationType: result.organizationType,
          phoneNumber: result.phoneNumber,
          email: result.email,
          streetAddress: result.streetAddress,
          city: result.city,
          state: result.state,
          zipCode: result.zipCode,
          latitude: result.latitude,
          longitude: result.longitude,
        });
      } catch (error) {
        console.error('Error fetching provider:', error);
      }
    };

    fetchProvider();
  }, [id]);
  
  const initialValues = {
    organizationName: '',
    organizationType: '',
    phoneNumber: '',
    email: '',
    streetAddress: '',
    city: '',
    state: '',
    zipCode: '',
    latitude: '',
    longitude: '',
  };

  const validationSchema = editProviderSchema;

  const onSubmit = async (values, { resetForm }) => {
    try {
        const data = encryptData(values);
        const response = await editProviderApi(data, id, headers); 
        toast.success(response.data.message,toastOptions);
        navigate("/admin/dashboard");
        resetForm();
    } catch (error) {
        toast.error(error.response.data.message, toastOptions);
    }
  };

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit,
  });




  return (
    <Box className="auth-page" sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
      <Box className="auth-form" sx={{ width: "70%", height: "1000px", padding: "20px", border: "1px solid gray",  borderRadius: "10px", marginTop: "2%", marginBottom: "2%", boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px"}}>
        <Typography variant="h4" gutterBottom align="center" sx={{color: "#0870AF "}}>
          Edit Location
        </Typography>
        <form onSubmit={formik.handleSubmit}>
        <Box className="input-field-section" sx={{ height: "80px"}}>
            <TextField
            fullWidth
            id="organizationName"
            name="organizationName"
            label="Organization Name"
            value={formik.values.organizationName}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.organizationName && Boolean(formik.errors.organizationName)}
            helperText={formik.touched.organizationName && formik.errors.organizationName}
            />
        </Box>
        <Box className="input-field-section" sx={{ height: "80px"}}>
            <TextField
                fullWidth
                id="organizationType"
                name="organizationType"
                label="Organization Type"
                value={formik.values.organizationType}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.organizationType && Boolean(formik.errors.organizationType)}
                helperText={formik.touched.organizationType && formik.errors.organizationType}
            />
        </Box>
        <Box className="input-field-section" sx={{ height: "80px"}}>
            <TextField
                fullWidth
                id="phoneNumber"
                name="phoneNumber"
                label="Phone Number"
                value={formik.values.phoneNumber}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.phoneNumber && Boolean(formik.errors.phoneNumber)}
                helperText={formik.touched.phoneNumber && formik.errors.phoneNumber}
            />
        </Box>
        <Box className="input-field-section" sx={{ height: "80px"}}>
            <TextField
                fullWidth
                id="email"
                name="email"
                label="Email"
                type="email"
                value={formik.values.email}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.email && Boolean(formik.errors.email)}
                helperText={formik.touched.email && formik.errors.email}
            />
        </Box>
        <Box className="input-field-section" sx={{ height: "80px"}}>
            <TextField
            fullWidth
            id="streetAddress"
            name="streetAddress"
            label="Street Address"
            value={formik.values.streetAddress}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.streetAddress && Boolean(formik.errors.streetAddress)}
            helperText={formik.touched.streetAddress && formik.errors.streetAddress}
            />
        </Box>
        <Box className="input-field-section" sx={{ height: "80px"}}>
            <TextField
            fullWidth
            id="city"
            name="city"
            label="City"
            value={formik.values.city}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.city && Boolean(formik.errors.city)}
            helperText={formik.touched.city && formik.errors.city}
            />
        </Box>
        <Box className="input-field-section" sx={{ height: "80px"}}>
            <TextField
            fullWidth
            id="state"
            name="state"
            label="State"
            value={formik.values.state}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.state && Boolean(formik.errors.state)}
            helperText={formik.touched.state && formik.errors.state}
            />
        </Box>
        <Box className="input-field-section" sx={{ height: "80px"}}>
            <TextField
                fullWidth
                id="zipCode"
                name="zipCode"
                label="Zip Code"
                value={formik.values.zipCode}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.zipCode && Boolean(formik.errors.zipCode)}
                helperText={formik.touched.zipCode && formik.errors.zipCode}
            />
        </Box>
        <Box className="input-field-section" sx={{ height: "80px"}}>
            <TextField
            fullWidth
            id="latitude"
            name="latitude"
            label="Latitude"
            value={formik.values.latitude}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.latitude && Boolean(formik.errors.latitude)}
            helperText={formik.touched.latitude && formik.errors.latitude}
            />
        </Box>
        <Box className="input-field-section" sx={{ height: "80px"}}>
            <TextField
            fullWidth
            id="longitude"
            name="longitude"
            label="Longitude"
            value={formik.values.longitude}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.longitude && Boolean(formik.errors.longitude)}
            helperText={formik.touched.longitude && formik.errors.longitude}
            />
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', marginTop: 2 }}>
          <Button type="submit" variant="contained">
            Update
          </Button>
          <Button
            variant="outlined"
            onClick={() => {
              navigate('/admin/dashboard');
          }}
            sx={{ marginLeft: 2 }}
          >
            Cancel
          </Button>
        </Box>
        </form>
        
      </Box>
    </Box>
  );
};

export default EditProvider;
